exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-5e4608b6]{display:inline-block;font-size:14px;line-height:50px;margin-left:8px}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-5e4608b6]{color:#97a8be;cursor:text;font-size:12px}\n", ""]);

// exports
